import { render } from "./WorkspaceView.vue?vue&type=template&id=271b3150&ts=true"
import script from "./WorkspaceView.vue?vue&type=script&lang=ts"
export * from "./WorkspaceView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__